import { SESSION_STATUS_LABEL, sessionTitle, AUDIT_ACTION_LABEL } from '../csConstants';

function formatAuditTime(raw) {
  if (!raw) return '—';
  try {
    const d = new Date(raw);
    if (Number.isNaN(d.getTime())) return String(raw);
    return d.toLocaleString();
  } catch {
    return String(raw);
  }
}

export default function SessionSidePanel({
  session,
  agentId,
  ending,
  claiming,
  onClaim,
  onTransfer,
  onEnd,
  onInviteRating,
  invitingRating,
  readOnly,
  watching,
  onWatch,
  onUnwatch,
  onForceAssign,
  onForceRelease,
  onForceTransfer,
  onSoftAssign,
  auditSummary,
  auditLoading,
}) {
  if (!session) {
    return (
      <div className="cs-panel">
        <div className="cs-panel__head">案件資訊</div>
        <div className="cs-empty">選取左側 Session</div>
      </div>
    );
  }

  const status = SESSION_STATUS_LABEL[session.status] || session.status || '—';
  const ended = session.status === 'ENDED' || session.status === 'ABANDONED';
  const events = auditSummary?.events || [];

  return (
    <div className="cs-panel">
      <div className="cs-panel__head">案件資訊</div>
      <div className="cs-side">
        <dl>
          <dt>會員</dt>
          <dd>{sessionTitle(session)}</dd>
          <dt>會員 ID</dt>
          <dd>{session.customerMemberId ?? '—'}</dd>
          <dt>Session</dt>
          <dd>{session.sessionNo || session.sessionId}</dd>
          <dt>狀態</dt>
          <dd>{status}</dd>
          {ended && session.endReason ? (
            <>
              <dt>結束原因</dt>
              <dd>{session.endReason}</dd>
            </>
          ) : null}
          <dt>分類 / 語系 / 優先級</dt>
          <dd>{[session.category, session.language, session.priority].filter(Boolean).join(' / ') || '—'}</dd>
          <dt>業務綁定</dt>
          <dd>
            {[session.businessSystem, session.businessType, session.businessId].filter(Boolean).join(' / ') || '—'}
          </dd>
          <dt>Conversation</dt>
          <dd>{session.conversationId ?? '—'}</dd>
        </dl>
        <div className="cs-side__actions">
          {!readOnly && !ended ? (
            <>
              {(session.status === 'WAITING' || session.status == null) && onClaim ? (
                <button
                  type="button"
                  className="btn btn-primary"
                  disabled={claiming || session.canClaim === false}
                  title={
                    session.canClaim === false
                      ? (session.eligibilityReasonCodes || []).join(', ') || '目前不可接手'
                      : '接手後即可發訊'
                  }
                  onClick={onClaim}
                >
                  {claiming ? '接手中…' : '接手開始對話'}
                </button>
              ) : null}
              <button type="button" className="btn btn-secondary" onClick={onTransfer}>
                轉接
              </button>
              <button
                type="button"
                className="btn btn-danger"
                disabled={ending || !(session.status === 'ACTIVE' || session.status === 'TRANSFERRING')}
                onClick={onEnd}
              >
                {ending ? '結束中…' : '結束服務'}
              </button>
              {onInviteRating ? (
                <button
                  type="button"
                  className="btn btn-secondary"
                  disabled={
                    invitingRating
                    || !(session.status === 'ACTIVE' || session.status === 'TRANSFERRING' || session.status === 'ENDED')
                  }
                  onClick={onInviteRating}
                >
                  {invitingRating ? '邀評中…' : '邀請評價'}
                </button>
              ) : null}
            </>
          ) : null}
          {ended && onInviteRating && session.status === 'ENDED' ? (
            <button
              type="button"
              className="btn btn-secondary"
              disabled={invitingRating}
              onClick={onInviteRating}
            >
              {invitingRating ? '邀評中…' : '邀請評價'}
            </button>
          ) : null}
          {readOnly && !ended ? (
            <>
              {watching ? (
                <button type="button" className="btn btn-secondary" onClick={onUnwatch}>結束監看</button>
              ) : (
                <button type="button" className="btn btn-primary" onClick={onWatch}>開始監看</button>
              )}
              <button type="button" className="btn btn-secondary" onClick={onSoftAssign}>Soft Assign</button>
              <button type="button" className="btn btn-secondary" onClick={onForceAssign}>Force Assign</button>
              <button type="button" className="btn btn-warning" onClick={onForceRelease}>Force Release</button>
              <button type="button" className="btn btn-danger" onClick={onForceTransfer}>Force Transfer</button>
            </>
          ) : null}
          {ended ? (
            <div className="cs-hint" style={{ padding: 0 }}>已結束案件（唯讀）</div>
          ) : null}
          {agentId ? (
            <div className="cs-hint" style={{ padding: 0 }}>目前 Agent ID：{agentId}</div>
          ) : null}
        </div>

        <div className="cs-panel__head" style={{ marginTop: 12 }}>Audit 摘要</div>
        {auditLoading ? <div className="cs-hint">載入 Audit…</div> : null}
        {!auditLoading && !events.length ? (
          <div className="cs-empty">尚無事件</div>
        ) : null}
        <ul className="cs-audit-list">
          {events.map((ev, idx) => (
            <li key={`${ev.action}-${ev.occurredAt}-${idx}`} className="cs-audit-item">
              <div className="cs-audit-item__title">
                {AUDIT_ACTION_LABEL[ev.action] || ev.action}
              </div>
              <div className="cs-audit-item__meta">
                {formatAuditTime(ev.occurredAt)}
                {ev.actorType ? ` · ${ev.actorType}` : ''}
                {ev.actorId != null ? ` #${ev.actorId}` : ''}
              </div>
              {ev.detail ? <div className="cs-audit-item__detail">{ev.detail}</div> : null}
            </li>
          ))}
        </ul>
        {auditSummary?.source ? (
          <div className="cs-hint">來源：{auditSummary.source}</div>
        ) : null}
      </div>
    </div>
  );
}
